// El aviso de la campana cuando Odoo corrige un fichaje lleva en `type` la clave
// "fichaje:<id de asistencia>:<in|out>:<epoch en segundos del valor nuevo>" (la crea
// backend/lib/avisoFichaje.js). De ahi sale el dia de Madrid al que lleva el aviso, sin
// columna de enlace en notifications.
export function diaDeAvisoFichaje(type) {
  const m = /^fichaje:\d+:(?:in|out):(\d+)$/.exec(String(type || ""));
  if (!m) return null;
  return new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Madrid" }).format(new Date(Number(m[1]) * 1000));
}
